// 重置message，防止重复点击重复弹出message弹框
import {ElMessage, type MessageOptions} from 'element-plus';

let messageInstance: any = null;

export default function DoneMessage(options: MessageOptions) {
    if (messageInstance) {
        messageInstance.close();
    }
    messageInstance = ElMessage(options);
    return messageInstance;
}
